import { render, staticRenderFns } from "./ComNotice.vue?vue&type=template&id=138fab94&scoped=true"
import script from "./ComNotice.vue?vue&type=script&lang=js"
export * from "./ComNotice.vue?vue&type=script&lang=js"
import style0 from "./ComNotice.vue?vue&type=style&index=0&id=138fab94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138fab94",
  null
  
)

export default component.exports